module.exports = __webpack_public_path__ + "media/brands/amex-2a32f5ae.png";